import React from "react";

const AdminStats = ({
  totalCount = 0,
  registeredCount = 0,
  notRegisteredCount = 0,
  clearedCount = 0,
  pendingDuesCount = 0,
  paidCount = 0,
  inPersonCount = 0,
  courierCount = 0,
}) => {
  const actualCleared = clearedCount !== undefined ? clearedCount : paidCount;
  const actualRegistered =
    registeredCount !== undefined
      ? registeredCount
      : (inPersonCount || 0) + (courierCount || 0);
  const actualNotRegistered =
    notRegisteredCount !== undefined
      ? notRegisteredCount
      : Math.max(0, totalCount - actualRegistered);

  return (
    <section className="admin-stats-grid">
      {/* 1. Total Graduates */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="Total Graduates">
          Total Graduates
        </div>
        <div className="admin-stat-value">
          {totalCount}
        </div>
      </div>

      {/* 2. Registered */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="Registered">
          Registered
        </div>
        <div className="admin-stat-value" style={{ color: "#047857" }}>
          {actualRegistered}{" "}
          <span
            style={{
              fontSize: "12px",
              color: "#64748b",
              fontWeight: 500,
            }}
          >
            ({totalCount ? Math.round((actualRegistered / totalCount) * 100) : 0}%)
          </span>
        </div>
      </div>

      {/* 3. Not Registered */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="Not Registered">
          Not Registered
        </div>
        <div className="admin-stat-value" style={{ color: "#64748b" }}>
          {actualNotRegistered}{" "}
          <span
            style={{
              fontSize: "12px",
              color: "#94a3b8",
              fontWeight: 500,
            }}
          >
            ({totalCount ? Math.round((actualNotRegistered / totalCount) * 100) : 0}%)
          </span>
        </div>
      </div>

      {/* 4. Dues Cleared */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="Dues Cleared">
          Dues Cleared
        </div>
        <div className="admin-stat-value" style={{ color: "#0f172a" }}>
          {actualCleared}{" "}
          <span
            style={{
              fontSize: "12px",
              color: "#64748b",
              fontWeight: 500,
            }}
          >
            ({totalCount ? Math.round((actualCleared / totalCount) * 100) : 0}%)
          </span>
        </div>
      </div>

      {/* 5. Pending Dues */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="Pending Dues">
          Pending Dues
        </div>
        <div
          className="admin-stat-value"
          style={{ color: pendingDuesCount > 0 ? "#dc2626" : "#0f172a" }}
        >
          {pendingDuesCount}
        </div>
      </div>

      {/* 6. In-Person Attendees */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="In-Person Attendees">
          In-Person
        </div>
        <div className="admin-stat-value">
          {inPersonCount}
        </div>
      </div>

      {/* 7. Courier Deliveries */}
      <div className="admin-stat-card">
        <div className="admin-stat-title" title="Courier Deliveries">
          Courier
        </div>
        <div className="admin-stat-value">
          {courierCount}
        </div>
      </div>
    </section>
  );
};

export default AdminStats;
